import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, CardBody, CardHeader, Button, Alert } from "reactstrap";
import { MdAdd } from "react-icons/lib/md";
import LoadingScreen from "react-loading-screen";

// Redux
import {
  listarAutos,
  setAutoSeleccionado,
  eliminarAuto
} from "../../redux/aZeroAutos";
import {
  selectAutos,
  selectIsLoading,
  selectError
} from "../../redux/selectors";

// Componentes
import TablaVehiculos from "../../components/TablaVehiculos";
import FiltrosVehiculos from "../../components/FiltrosVehiculos";

const ListadoVehiculos = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // Selectors
  const autos = useSelector(selectAutos);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);

  // Filtros locales
  const [filtros, setFiltros] = useState({
    placa: "",
    marca: ""
  });

  // Carga inicial
  useEffect(() => {
    dispatch(listarAutos());
  }, [dispatch]);

  // Manejo de cambios en filtros
  const handleFiltroChange = (name, value) => {
    setFiltros((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleLimpiarFiltros = () => {
    setFiltros({
      placa: "",
      marca: ""
    });
  };

  // Filtrado lógico local
  const autosFiltrados = autos.filter((auto) => {
    const coincidePlaca = auto.placa
      .toLowerCase()
      .includes(filtros.placa.trim().toLowerCase());
    const coincideMarca = filtros.marca
      ? auto.marca.toLowerCase() === filtros.marca.toLowerCase()
      : true;
    return coincidePlaca && coincideMarca;
  });

  // Navegación
  const handleNuevo = () => {
    dispatch(setAutoSeleccionado(null)); // Limpiar selección para modo creación
    history.push("/zero/vehiculos/crear");
  };

  const handleEditar = (auto) => {
    dispatch(setAutoSeleccionado(auto));
    history.push(`/zero/vehiculos/editar/${auto.id}`);
  };

  const handleEliminar = async (auto) => {
    if (window.confirm(`¿Está seguro de que desea eliminar el vehículo con placa ${auto.placa}?`)) {
      const exitoso = await dispatch(eliminarAuto(auto.id));
      if (exitoso) {
        alert("Vehículo eliminado correctamente.");
      }
    }
  };

  return (
    <LoadingScreen
      loading={isLoading}
      bgColor="#ffffff"
      spinnerColor="#007bff"
      textColor="#676767"
      text="Cargando vehículos..."
    >
      <div className="container-fluid py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h1 className="h3 mb-0 text-gray-800 font-weight-bold">Módulo Zero — CRUD Vehículos</h1>
            <p className="text-muted mb-0">Módulo de referencia y buenas prácticas de desarrollo.</p>
          </div>
          <Button color="primary" onClick={handleNuevo} className="d-inline-flex align-items-center">
            <MdAdd className="mr-1" /> Nuevo Vehículo
          </Button>
        </div>

        {error && (
          <Alert color="danger" className="mb-4">
            <strong>Error:</strong> {error}
          </Alert>
        )}

        {/* Filtros */}
        <FiltrosVehiculos
          filtros={filtros}
          onChange={handleFiltroChange}
          onLimpiar={handleLimpiarFiltros}
        />

        {/* Listado */}
        <Card className="shadow-sm border-0">
          <CardHeader className="bg-white py-3 border-bottom-0">
            <h5 className="mb-0 font-weight-bold text-dark">Listado de Vehículos Registrados</h5>
          </CardHeader>
          <CardBody className="pt-0">
            <TablaVehiculos
              vehiculos={autosFiltrados}
              isLoading={isLoading}
              onEditar={handleEditar}
              onEliminar={handleEliminar}
            />
          </CardBody>
        </Card>
      </div>
    </LoadingScreen>
  );
};

export default ListadoVehiculos;
